import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const createMissionAction = createAsyncThunk(
    'create-mission',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.post(`/admins/api/add-mission`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const createMissionSlice = createSlice({
    name: 'create-mission',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(createMissionAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(createMissionAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(createMissionAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const createMissionReducer = createMissionSlice.reducer    